(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('HomeController', HomeController);

    /* @ngInject */
    function HomeController($timeout, $stateParams) {
        var vm = this;
    }

})(angular);
